<template>
    <b-container fluid>
        <header-buttons
                :buttons="headerButtons"
                @onNewMailing="newMailing"
        ></header-buttons>
        <b-row>
            <b-col cols="12">
                <admin-mailing-table
                        :key="tablekey">
                </admin-mailing-table>
            </b-col>
        </b-row>
        <inter-modal
                title-icon="flaticon-mail"
                :buttonPrimary="buttonPrimary"
                :title="titleModal"
                :visible="showModal"
                @onPrimaryClick="sendMailing">
            <admin-mailings-form
                    @onUploaded="(value) => { attachments = value }"
                    ref="adminMailingsForm"
                    :mailing="mailing"></admin-mailings-form>
        </inter-modal>
    </b-container>
</template>

<script>
    import HeaderButtons from "../../../components/headers-buttons/HeaderButtons";
    import AdminMailingTable from "../components/AdminMailingsTable";
    import InterModal from "../../../components/modal/InterModal";
    import Mailing from "@/models/Mailing";
    import AdminMailingsForm from "../forms/AdminMailingsForm";
    import {mapActions} from 'vuex';

    export default {
        name: "AdminMailingsListView",
        components: {AdminMailingsForm, InterModal, AdminMailingTable, HeaderButtons},
        data() {
            return {
                headerButtons: [
                    {
                        label: 'Nuova mailing',
                        onClick: 'onNewMailing',
                    }
                ],
                tablekey: 1,
                showModal: false,
                titleModal: 'Nuova mailing',
                buttonPrimary: {
                    label: 'Invia',
                    confirm: true
                },
                mailing: Object.assign({}, Mailing),
                attachments: []
            }
        },
        mounted() {
            this.$root.$on('bv::modal::hide', () => {
                this.showModal = false;
            })
        },
        methods: {

            ...mapActions({
                adminMailingsSend: 'adminMailingsSend',
            }),

            newMailing: function () {
                this.mailing = Object.assign({}, Mailing);
                this.attachments = [];
                this.showModal = true;
            },

            sendMailing: function () {
                let data = this.mailing;
                data.recipies = this.$refs.adminMailingsForm.societies;
                data.attachments = this.attachments;
                this.adminMailingsSend(data)
                    .then(() => {
                        this.$bvToast.toast('Mailing inviata correttamente', {
                            title: 'Success',
                            variant: 'success'
                        });
                        this.showModal = false;
                        this.tablekey += 1;
                    }).catch(() => {
                    this.$bvToast.toast('Mailing non inviata', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                })
            },

        }
    }
</script>

<style scoped>

</style>
